import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const ProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem('token');
  const userType = sessionStorage.getItem('userType');

  // If no token or user is not a customer
  if (!token || userType !== 'customer') {
    sessionStorage.clear();
    return <Navigate to="/login" replace />;
  }

  try {
    const decoded = jwtDecode(token);
    const currentTime = Date.now() / 1000;

    // Check if token is expired
    if (decoded.exp < currentTime) {
      sessionStorage.clear();
      return <Navigate to="/login" replace />;
    }
  } catch (error) {
    console.error('Token decode error:', error);
    sessionStorage.clear();
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;
